export const createJiraTicket = async (payload) => {
  try {
    const response = await fetch(`${process.env.GATSBY_API_URL}/jira/ticket`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    console.log('Jira Ticket Created:', data);
  } catch (error) {
    console.error('Error:', error);
  }
};
